export default __webpack_public_path__ + "static/media/Listmodels.8dbb7bc1.svg";